<template>
  <div>
    <el-container v-if="$route.meta.keepAlive">
      <!-- <Breadcrumb v-if="$route.meta.keepAlive" /> -->
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <router-view v-else />
  </div>
</template>
<script>
// import Breadcrumb from "@/components/breadcrumb";
export default {
  // components: {
  //   Breadcrumb
  // },
  data() {
    return {};
  },
  methods: {}
};
</script>